"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = chunkSpeakers;

var _lodash = require("lodash");

var _Term = _interopRequireDefault(require("../Term"));

var _groupTermsBy = _interopRequireDefault(require("./groupTermsBy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function sentencesToChunks(sentences, chunkSize) {
  if (!sentences.length) return [sentences];
  var start = (0, _lodash.first)(sentences).start;
  var chunks = (0, _groupTermsBy["default"])(sentences, function (sentence) {
    return Math.floor((sentence.start - start) / chunkSize);
  });
  return (0, _lodash.map)(chunks, "terms");
}

function chunkSpeakers(speakersArray, chunkSize) {
  if (chunkSize === void 0) {
    chunkSize = 12000;
  }

  return speakersArray.reduce(function (list, speaker) {
    var chunks = sentencesToChunks(speaker.value, chunkSize);

    if (chunks.length > 1) {
      speaker.value = chunks.shift();
      list.push(speaker);

      while (chunks.length) {
        var newSpeaker = new _Term["default"](speaker); // clone it

        newSpeaker.value = chunks.shift();
        list.push(newSpeaker);
      }
    } else {
      list.push(speaker);
    }

    return list;
  }, []);
}